import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ControlContainer, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { AbstractControlToFormControlPipe } from '../../../pipes/abstract-control-to-form-control.pipe';
import { WithReadonly } from '../base/with-readonly';

@Component({
  selector: 'shared-input-text',
  imports: [ReactiveFormsModule, AbstractControlToFormControlPipe, InputTextModule],
  templateUrl: './input-text.component.html',
  styleUrls: ['./input-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
})
export class InputTextComponent extends WithReadonly {
  @Input() name: string | undefined;
  @Input() placeholder: string | null = '';
  @Input() autocomplete: 'on' | 'off' = 'on';
}
